import script from "./verificationCode.vue?vue&type=script&setup=true&lang=js"
export * from "./verificationCode.vue?vue&type=script&setup=true&lang=js"

import "./verificationCode.vue?vue&type=style&index=0&id=0eaad858&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eaad858"]])

export default __exports__